import { getNoaId } from "../../utils/session.utils";
import { setUsersError } from "../../store/slices/errors";
import apiClient from "../../utils/api.client";
const serviceName = "gamma-users";

const createUser = async (payload) => {
  try {
    const response = await apiClient.post(`${serviceName}/users`, payload);
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at createUser EP: ", e);
    throw e;
  }
};

const editUser = async (payload) => {
  try {
    const response = await apiClient.put(`${serviceName}/users`, payload);
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at editUser EP: ", e);
    throw e;
  }
};

const deleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`${serviceName}/users/${userId}`);
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at deleteUser EP: ", e);
    throw e;
  }
};

const searchUser = async (payload) => {
  try {
    const response = await apiClient.get(
      `${serviceName}/users?orderCriteria=ASC&orderField=lastname&query=${payload}`,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at searchUser EP: ", e);
    throw e;
  }
};

const searchUsersByOrganization = async (
  page,
  perPage,
  dispatch,
  filters,
  query,
) => {
  const noaId = getNoaId();
  try {
    const response = await apiClient.get(
      `${serviceName}/organizations/${noaId}/users?pageNumber=${page || 1}&pageSize=${perPage || 10}&orderCriteria=${filters?.increasing ? "ASC" : "DESC"}&orderField=${filters?.name || "firstname"}${query ? `&query=${query}` : ""}`,
    );
    const data = response.data;

    dispatch(setUsersError({ error: false }));
    return data;
  } catch (e) {
    console.error("Error at searchUsersByOrganization EP: ", e);
    dispatch(setUsersError({ error: true, code: e.status || e.message }));
  }
};

const userService = {
  createUser,
  deleteUser,
  editUser,
  searchUser,
  searchUsersByOrganization,
};

export default userService;
